import { useQuery } from "@tanstack/react-query";

import { get } from "../helpers/HTTP";
import getQueryKeys from "./getQueryKeys";

import type { WorkspaceAccount } from "../types";

async function getWorkspaceAccountsRequest(
  workspaceId: string,
): Promise<WorkspaceAccount[]> {
  return (await get(`workspaces/${workspaceId}/accounts`)).accounts;
}

export default function useWorkspaceAccounts(workspaceId: string) {
  const {
    data: workspaceAccounts,
    isLoading: isLoadingWorkspaceAccounts,
    error: workspaceAccountsError,
    refetch: refetchWorkspaceAccounts,
  } = useQuery({
    queryKey: getQueryKeys(workspaceId).workspaceKeys.accounts(),
    queryFn: () => getWorkspaceAccountsRequest(workspaceId),
  });

  return {
    workspaceAccounts,
    isLoadingWorkspaceAccounts,
    refetchWorkspaceAccounts,
    workspaceAccountsError,
  };
}
